
export default {
  name: "Products",

  data: function () {
    return {
      isMoreProducts: false
    }
  },

  props: {
    products: {
      type: Array,
      default: () => {
        return {}
      }
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isHideFilter: {
      type: Boolean,
      default: false
    },

    versionProduct: {
      typr: Number,
      default: 1
    }
  },

  computed: {
    productsList: function () {
      const _isMobile = Boolean(this.$store.state.device?.device?.isMobile)
      if ((!_isMobile && this.products.length <= 6) || (_isMobile && this.products.length <= 4)) {
        return this.products
      }
      if (!this.isHideFilter) {
        return this.products
      }
      if (!this.isMoreProducts) {
        const count = Boolean(this.$store.state.device?.device?.isMobile) ? 2 : 6;
        return [...this.products].splice(0, count);
      }
      return this.products
    },
    isShowMore: function () {
      return Boolean(this.productsList.length !== this.products.length)
      // return Boolean(this.products.length > 6); // если нужно включить сворачивание
    },
    isShowMoreTitle: function () {
      return this.isMoreProducts ? 'Свернуть' : 'Показать еще'
    }
  },

  components: {
    Pagination: () => import("~/components/UI/Pagination"),
    TransportCardV2: () => import("~/components/our-vehicles/TransportCardV2"),
    ProductCard: () => import("~/components/category/ProductCardSmallImage.vue"),
  },

  methods: {
    changePage: function (newPage) {
      this.$emit('onChangePage', newPage);

      const headerHeight = document.getElementById('header').getBoundingClientRect().height;
      const bodyTop = this.$refs.refProducts.getBoundingClientRect().top + window.pageYOffset;
      const nextScrollTop = bodyTop - headerHeight - (headerHeight / 100 * 10);
      window.scrollTo({
        top: nextScrollTop,
        behavior: "smooth"
      });
    },
    toggleMoreProducts: function () {
      this.isMoreProducts = !this.isMoreProducts;
    }
  }
}
